import React, { useState } from 'react';

const TimeSlotModal = ({ onClose, onSave }) => {
  const [startTime, setStartTime] = useState('');
  const [endTime, setEndTime] = useState('');

  const handleSave = () => {
    onSave({ startTime, endTime });
  };

  return (
    <div className="fixed inset-0 bg-gray-800 bg-opacity-75 flex items-center justify-center">
      <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full">
        <h2 className="text-2xl font-bold mb-4">Aggiungi Time Slot</h2>
        <label className="block mb-2 text-lg font-semibold">Orario Inizio</label>
        <input
          type="time"
          value={startTime}
          onChange={(e) => setStartTime(e.target.value)}
          className="w-full border p-2 rounded mb-4"
        />
        <label className="block mb-2 text-lg font-semibold">Orario Fine</label>
        <input
          type="time"
          value={endTime}
          onChange={(e) => setEndTime(e.target.value)}
          className="w-full border p-2 rounded mb-4"
        />
        <div className="flex justify-end">
          <button onClick={onClose} className="bg-gray-600 text-white px-4 py-2 rounded-lg shadow-md hover:bg-gray-800 mr-2">Annulla</button>
          <button onClick={handleSave} className="bg-[#3e96ac] text-white px-4 py-2 rounded-lg shadow-md hover:bg-[#e06615]">Salva</button>
        </div>
      </div>
    </div>
  );
};

export default TimeSlotModal;